import { Topics } from './topics';

export abstract class IEvent {
    public static readonly TOPIC: Topics;
    public eid?: string;

    abstract get partitionKey(): string;

    constructor() {}
}

/**
 * NEVER EVER CHANGE THIS VALUE
 * This is used to identify tracked events in the analytics service
 */
const TRACKED_EVENT_STRING = 'TRACKED_EVENT' as const;

/**
 * Events that are tracked by the analytics service
 */
export abstract class ITrackedEvent extends IEvent {
    /**
     * NEVER EVER CHANGE THIS VALUE
     * This is used to identify tracked events in the analytics service
     */
    public trackedEventString = TRACKED_EVENT_STRING;

    public _external_name?: string;
    public _external_ignore_fields?: string[];

    public abstract userId: string;

    static isTrackedEvent(object: any): boolean {
        return object?.trackedEventString === TRACKED_EVENT_STRING;
    }
}
